import Cookies from "js-cookie";
import { apiService, setAuthHeader } from "./api";
import { ACCESS_TOKEN_KEY, COOKIES_COMPANY_ID } from "../utils/constants";
import { LoadData } from "../models";

export async function fetchLoads({ status }: { status?: string }) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  let url = `/company/${companyId}/load?filter=matched&role=carrier`;

  if (status) {
    url += `&status=${status}`;
  }

  const response = await apiService.get(url);

  console.log("load resdata", response.data);

  const resp = response.data["loads"] as any[];

  const data = resp.map<LoadData>((item) => ({
    ...item,
    equipmentId: item.carrierEquipmentID ?? "--",
    equipmentNum: item.carrierEquipmentNum ?? "--",
    equipmentType: item.carrierEquipmentType ?? "--",
    lp: item.carrierEquipmentLp ?? "--",
    pickupTime: item.pickupTime ? item.pickupTime / 1000 : undefined,
    dropOffTime: item.dropOffTime ? item.dropOffTime / 1000 : undefined,
    driver: item.driver
      ? {
          name: item.driver.name,
          email: item.driver.email,
          id: "",
          phoneNumber: item.driver.phoneNumber ?? "--",
          availability: [],
        }
      : undefined,
    status:
      item.status === "accepted"
        ? item.driverID
          ? "assigned"
          : "unassigned"
        : item.status,
  }));

  return data;
}

export async function fetchLoadDetails(loadID: number, showRoute?: boolean) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  let url = `/company/${companyId}/load/${loadID}`;

  if (showRoute) url += `?showRoute=true`;

  const response = await apiService.get(url);
  const { data } = response;

  return {
    ...data,
    equipmentId: data.carrierEquipmentID ?? "--",
    equipmentNum: data.carrierEquipmentNum ?? "--",
    equipmentType: data.carrierEquipmentType ?? "--",
    lp: data.carrierEquipmentLp ?? "--",
    pickupTime: data.pickupTime ? data.pickupTime / 1000 : undefined,
    dropOffTime: data.dropOffTime ? data.dropOffTime / 1000 : undefined,
    driver: data.driver
      ? {
          name: data.driver.name,
          email: data.driver.email,
          id: "",
          phoneNumber: data.driver.phoneNumber ?? "--",
          availability: [],
        }
      : undefined,
    status:
      data.status === "accepted"
        ? data.driverID
          ? "assigned"
          : "unassigned"
        : data.status,
  };
}

export async function markHeadingPickup(loadID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);

  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/load/heading-pickup`,
    {
      loadId: +loadID,
    }
  );

  return response.data["data"];
}

export async function checkInDropOff(loadID: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);
  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/load/execute-load`,
    {
      action: 'check_in_dropoff',
      loadId: +loadID,
    }
  );

  return response.data;
}

export async function breakSealAPI(loadID: string, sealNum: string) {
  const token = Cookies.get(ACCESS_TOKEN_KEY);
  const companyId = Cookies.get(COOKIES_COMPANY_ID);
  setAuthHeader(`${token}`);

  const response = await apiService.post(
    `/company/${companyId}/load/execute-load`,
    {
      action: 'break_seal',
      loadId: +loadID,
      sealNum
    }
  );

  return response.data;
}
